export type Team01 = 0 | 1;

const DEFAULT_PLAYER_IDS = [0, 1, 2, 3] as const;

function asTeam01(value: unknown): Team01 | null {
  return value === 0 || value === 1 ? value : null;
}

function asPlayerId(value: unknown): number | null {
  const n = Number(value);
  return Number.isInteger(n) && n >= 0 ? n : null;
}

export function legacyTeamOfPlayerId(playerId: unknown): Team01 | null {
  const n = asPlayerId(playerId);
  if (n == null) return null;
  if (n === 0 || n === 1) return 0;
  if (n === 2 || n === 3) return 1;
  return null;
}

export function buildPlayerIdToTeamMap(
  insightsJson: unknown,
): Record<number, Team01> {
  const out: Record<number, Team01> = {};
  const playerData = Array.isArray((insightsJson as any)?.player_data)
    ? (insightsJson as any).player_data
    : [];

  playerData.forEach((row: any, index: number) => {
    const team = asTeam01(row?.team);
    if (team == null) return;

    out[index] = team;

    const explicitPlayerId = asPlayerId(row?.player_id);
    if (explicitPlayerId != null) out[explicitPlayerId] = team;
  });

  return out;
}

export function teamOfPlayerIdFromMap(
  playerId: unknown,
  playerIdToTeam: Record<number, Team01> | null | undefined,
): Team01 | null {
  const n = asPlayerId(playerId);
  if (n == null) return null;

  const mapped = playerIdToTeam?.[n];
  if (mapped === 0 || mapped === 1) return mapped;

  return legacyTeamOfPlayerId(n);
}

export function playersForTeamFromMap(
  team: Team01,
  playerIdToTeam: Record<number, Team01> | null | undefined,
  playerIds: readonly number[] = DEFAULT_PLAYER_IDS,
): number[] {
  const mapped = playerIds.filter(
    (playerId) => teamOfPlayerIdFromMap(playerId, playerIdToTeam) === team,
  );
  if (mapped.length) return mapped;
  return team === 0 ? [0, 1] : [2, 3];
}
